@if (currentVisibility()) {
<section>
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{cancelConfirmDialogData.title}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <mat-dialog-content>
        <div class="my-dialog-content">
            <p class="mat-body-1">{{cancelConfirmDialogData.content}}</p>
        </div>
    </mat-dialog-content>
        <mat-dialog-actions align="center" class="dialog-actions">
        <button class="uscb-secondary-button" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">
            {{cancelConfirmDialogData.cancelButtonLabel}}
        </button>

        <button class="uscb-primary-button" (click)="confirm()" (keyup.enter)="confirm()" tabindex="0">
            {{cancelConfirmDialogData.confirmButtonLabel}}
        </button>
    </mat-dialog-actions>
</section>
}
